import sqlApiClient from '@/api/sqlApiClient'
import queries from '@/api/queries'

export default {
  getShopList () {
    return sqlApiClient.query(queries.centers).then(data => data.rows)
  },
  getShopDetail (id) {
    const query = `${queries.center_detail} WHERE center_id = ${Number(id)}`
    return sqlApiClient.query(query).then(data => data.rows[0])
  },
  updateWidgetDescription ({ centerId, descriptionField, description }) {
    const query = `
      UPDATE eci_centros SET "${descriptionField}" = $$${description}$$
      WHERE center_id = ${Number(centerId)}
      RETURNING *
    `
    return sqlApiClient.query(query).then(data => data.rows[0])
  },
  getProvincePostalcodes (provinceCode) {
    const query = `
      SELECT p.* FROM master_postal p
      WHERE code LIKE '${Number(provinceCode)}%'
    `
    return sqlApiClient.query(query).then(data => data.rows)
  },
  async getWidgetData ({ centerid, areatype, areas, widgets }) {
    if (areas.length === 0) {
      return { acum: {}, length: 1 }
    }

    const table = areatype === 'grids' ? 'master_geohash' : 'master_postal'
    const joinTable = areatype === 'grids' ? 'eci_zonas_geohashes' : 'eci_zonas_postal_codes'
    const geomField = areatype === 'grids' ? 'geohash' : 'code'

    const fields = widgets.flatMap(w => w.fields).map(f => `main."${f.field}"`)
    const whereClause = (areas.length === 1 && areas[0] === 'all')
      ? `JOIN "${joinTable}" secondary ON secondary."${geomField}" = main.code AND secondary.center_id = ${Number(centerid)}`
      : `WHERE main.code::text IN(${areas.map(a => `$$${a}$$`).join(',')})`
    const query = `SELECT ${fields.join(',')} FROM "${table}" main ${whereClause}`
    const dataFlat = await sqlApiClient.query(query).then(data => data.rows)
    return this.transformWidgetData(dataFlat)
  },
  transformWidgetData (data) {
    const acum = {}
    const length = {}
    for (const row of data) {
      for (const key in row) {
        acum[key] = acum[key] || 0
        length[key] = length[key] || 0

        const val = Number(row[key] || 0)
        acum[key] += val
        if (val > 0) {
          length[key]++
        }
      }
    }
    return { acum, length }
  },
  getCategoryOptions () {
    const query = 'SELECT distinct category FROM eci_poi_competencia'
    return sqlApiClient.query(query).then(data => data.rows.map(r => r.category).sort())
  },
  getBrandOptions ({ categories = [] }) {
    const filter = categories.length > 0
      ? `category IN (${categories.map(id => `$$${id}$$`).join()})`
      : 'TRUE'
    const query = `
      SELECT distinct brandname FROM eci_poi_competencia
      WHERE ${filter}
    `
    return sqlApiClient.query(query).then(data => data.rows.map(r => r.brandname).sort())
  }
}
